import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";

interface TimelineRowProps {
  label: string;
  value: string;
  bold?: boolean;
}

function TimelineRow({ label, value, bold }: TimelineRowProps) {
  const formatDateTime = (iso: string) => {
    return new Date(iso).toLocaleString("nb-NO", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="flex justify-between text-xs py-1 first:pt-0 last:pb-0 border-b border-border/30 last:border-0">
      <span className="text-muted-foreground">{label}</span>
      <span className={bold ? "font-semibold text-foreground" : "text-foreground"}>
        {formatDateTime(value)}
      </span>
    </div>
  );
}

interface AuctionTimelineCardProps {
  createdAt: string;
  submittedAt?: string | null;
  publishedAt?: string | null;
  startsAt?: string | null;
  endsAt?: string | null;
  closedAt?: string | null;
}

export function AuctionTimelineCard({
  createdAt,
  submittedAt,
  publishedAt,
  startsAt,
  endsAt,
  closedAt,
}: AuctionTimelineCardProps) {
  return (
    <Card className="shadow-sm border-border/50">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-semibold flex items-center gap-2">
          Tidslinje
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-1">
        <TimelineRow label="Opprettet" value={createdAt} />
        {submittedAt && <TimelineRow label="Sendt inn" value={submittedAt} />}
        {publishedAt && <TimelineRow label="Publisert" value={publishedAt} />}
        {startsAt && <TimelineRow label="Starter" value={startsAt} />}
        {endsAt && <TimelineRow label="Slutter" value={endsAt} bold />}
        {closedAt && <TimelineRow label="Lukket" value={closedAt} />}
      </CardContent>
    </Card>
  );
}
